(()=>{
  const WISHLIST_KEY='shopify-wishlist';
  const money=cents=>{
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:'INR'}).format((Number(cents)||0)/100).replace('₹','Rs. ')}catch(error){return `Rs. ${((Number(cents)||0)/100).toFixed(2)}`}
  };

  const wishlistPage=document.querySelector('[data-antar-wishlist-page]');
  if(wishlistPage){
    const grid=wishlistPage.querySelector('[data-antar-wishlist-grid]');
    const empty=wishlistPage.querySelector('[data-antar-wishlist-empty]');
    const loading=wishlistPage.querySelector('[data-antar-wishlist-loading]');
    const head=wishlistPage.querySelector('[data-antar-wishlist-head]');
    const count=wishlistPage.querySelector('[data-antar-wishlist-page-count]');
    const read=()=>window.AntarWishlist?.read?.()||(()=>{try{return (localStorage.getItem(WISHLIST_KEY)||'').split(',').map(v=>v.trim()).filter(Boolean)}catch(error){return []}})();
    let token=0;
    let pendingMoveHandle='';
    wishlistPage.addEventListener('submit',event=>{
      const form=event.target.closest('[data-antar-wishlist-move-form]');
      if(!form)return;
      const handle=form.dataset.wishlistHandle||'';
      pendingMoveHandle=handle;
      window.setTimeout(()=>{if(pendingMoveHandle===handle)pendingMoveHandle=''},5000);
    });
    document.addEventListener('antar:product-added',()=>{
      if(!pendingMoveHandle)return;
      const movedHandle=pendingMoveHandle;
      pendingMoveHandle='';
      const next=read().filter(handle=>handle!==movedHandle);
      if(window.AntarWishlist?.write)window.AntarWishlist.write(next);
      else{try{if(next.length)localStorage.setItem(WISHLIST_KEY,next.join(','));else localStorage.removeItem(WISHLIST_KEY)}catch(error){}}
      window.AntarWishlist?.sync?.();
      document.dispatchEvent(new CustomEvent('antar:wishlist-change',{detail:{items:next,count:next.length,handle:movedHandle,moved:true}}));
    });
    const render=async()=>{
      const current=++token;
      const handles=read();
      if(count)count.textContent=String(handles.length);
      if(head)head.hidden=handles.length===0;
      if(empty)empty.hidden=handles.length>0;
      if(!handles.length){if(grid)grid.innerHTML='';if(loading)loading.hidden=true;return}
      if(loading)loading.hidden=false;
      try{
        const cards=await Promise.all(handles.map(async handle=>{
          try{const response=await fetch(`/products/${encodeURIComponent(handle)}?view=wishlist`,{headers:{'X-Requested-With':'XMLHttpRequest'}});return response.ok?await response.text():''}catch(error){return ''}
        }));
        if(current!==token)return;
        if(grid)grid.innerHTML=cards.filter(Boolean).join('');
        window.AntarWishlist?.sync?.();
      }finally{if(current===token&&loading)loading.hidden=true}
    };
    render();
    document.addEventListener('antar:wishlist-change',render);
  }

  const shopAll=document.querySelector('[data-antar-shop-all]');
  if(shopAll){
    const input=shopAll.querySelector('[data-antar-shop-filter]');
    const clear=shopAll.querySelector('[data-antar-shop-filter-clear]');
    const count=shopAll.querySelector('[data-antar-shop-count]');
    const status=shopAll.querySelector('[data-antar-shop-status]');
    const empty=shopAll.querySelector('[data-antar-shop-filter-empty]');
    const cards=[...shopAll.querySelectorAll('[data-antar-shop-product]')];
    const groups=[...shopAll.querySelectorAll('[data-antar-shop-group]')];
    const normalize=value=>(value||'').toLocaleLowerCase(document.documentElement.lang||'en').trim();
    const applyFilter=()=>{
      const raw=input?.value||'';
      const query=normalize(raw);
      let visible=0;
      cards.forEach(card=>{
        const match=!query||normalize(card.dataset.search).includes(query);
        card.hidden=!match;
        if(match)visible+=1;
      });
      groups.forEach(group=>{
        const groupCards=[...group.querySelectorAll('[data-antar-shop-product]')];
        const groupVisible=groupCards.filter(card=>!card.hidden).length;
        group.hidden=groupVisible===0;
        const groupCount=group.querySelector('[data-antar-shop-group-count]');
        const groupLabel=group.querySelector('[data-antar-shop-group-label]');
        if(groupCount)groupCount.textContent=String(groupVisible);
        if(groupLabel)groupLabel.textContent=groupVisible===1?'product':'products';
      });
      if(count)count.textContent=String(visible);
      if(status)status.textContent=query?`${visible} ${visible===1?'match':'matches'} for “${raw.trim()}”`:'Grouped by collection';
      if(clear)clear.hidden=!query;
      if(empty)empty.hidden=visible>0;
    };
    input?.addEventListener('input',applyFilter);
    input?.addEventListener('keydown',event=>{if(event.key==='Escape'&&input.value){event.preventDefault();input.value='';applyFilter();input.focus();}});
    clear?.addEventListener('click',()=>{if(!input)return;input.value='';applyFilter();input.focus();});
    applyFilter();
  }

  const cartPage=document.querySelector('[data-antar-cart-page]');
  if(cartPage){
    let busy=false;
    const updateLine=async(row,quantity)=>{
      if(busy||!row)return;
      busy=true;row.classList.add('is-loading');
      try{
        const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(row.dataset.line),quantity:Math.max(0,Number(quantity)||0)})});
        if(!response.ok)throw new Error('Cart update failed');
        const cart=await response.json();
        if(quantity<=0){row.remove()}else{
          const item=cart.items[Number(row.dataset.line)-1];
          row.querySelector('[data-antar-cart-qty]').value=String(item?.quantity??quantity);
          const linePrice=row.querySelector('[data-antar-line-price]');if(linePrice&&item)linePrice.textContent=money(item.final_line_price);
        }
        [...cartPage.querySelectorAll('[data-antar-cart-row]')].forEach((node,index)=>node.dataset.line=String(index+1));
        cartPage.querySelector('[data-antar-cart-item-count]').textContent=String(cart.item_count);
        cartPage.querySelector('[data-antar-cart-total]').textContent=money(cart.total_price);
        document.dispatchEvent(new CustomEvent('antar:cart-change',{detail:{count:cart.item_count,cart}}));
        if(cart.item_count===0)window.location.reload();
      }catch(error){window.location.reload()}finally{busy=false;row.classList.remove('is-loading')}
    };
    cartPage.addEventListener('click',async event=>{
      const recommendationButton=event.target.closest('[data-antar-cart-reco-add]');
      if(recommendationButton){
        const variantId=recommendationButton.dataset.variantId;
        if(!variantId||recommendationButton.disabled)return;
        recommendationButton.disabled=true;
        recommendationButton.classList.add('loading');
        try{
          const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})});
          if(!response.ok)throw new Error('Recommendation add failed');
          window.location.reload();
        }catch(error){
          recommendationButton.disabled=false;
          recommendationButton.classList.remove('loading');
        }
        return;
      }
      const row=event.target.closest('[data-antar-cart-row]');if(!row)return;
      const input=row.querySelector('[data-antar-cart-qty]');
      if(event.target.closest('[data-antar-cart-minus]'))updateLine(row,Math.max(0,(Number(input.value)||1)-1));
      if(event.target.closest('[data-antar-cart-plus]'))updateLine(row,(Number(input.value)||0)+1);
      if(event.target.closest('[data-antar-cart-remove]'))updateLine(row,0);
    });
    cartPage.addEventListener('change',event=>{if(event.target.matches('[data-antar-cart-qty]'))updateLine(event.target.closest('[data-antar-cart-row]'),event.target.value)});
  }
})();